export function validateBid(bidPrice, numberOfCredits, creditsToSell) {
  if (bidPrice <= 0) {
    return { message: "Bid price must be greater than 0.", success: false };
  }
  if (numberOfCredits <= 0 || !Number.isInteger(numberOfCredits)) {
    return {
      message: "Number of credits must be greater than zero",
      success: false,
    };
  }

  if (numberOfCredits > creditsToSell) {
    return {
      message:
        "Number of credits cannot be greater than available credits to sell.",
      success: false,
    };
  }
  return { messgae: "Validation successful.", success: true };
}
